import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";

const apiClient = new APIClient();

const ModalEditarRede = ({
  show,
  rede,
  fetchRedes,
  setShowModal,
  setRedes,
}) => {
  const [loading, setLoading] = useState(false);
  const [nome, setNome] = useState(rede.nome);
  const [moeda, setMoeda] = useState(rede.moeda);
  const [networkId, setNetworkId] = useState(rede.network_id);
  const [decimals, setDecimals] = useState(rede.decimals);
  const [rpc, setRpc] = useState(rede.rpc || "");
  const [blockExplorer, setBlockExplorer] = useState(rede.block_explorer || "");
  const [taxaRetirada, setTaxaRetirada] = useState(rede.taxa_retirada);

  const toggle = () => setShowModal(!show);

  const atualizarRede = async () => {
    setLoading(true);
    const formData = {
      nome,
      moeda,
      decimals,
      rpc,
      network_id: networkId,
      block_explorer: blockExplorer,
      taxa_retirada: taxaRetirada,
    };
    
    const response = await apiClient.put(`/rede/${rede.id}`, formData);
    setLoading(false);
    
    if (response.sucesso) {
      toast.success("Rede atualizada com sucesso!");
      setRedes(await fetchRedes());
      setShowModal(false);
    } else {
      toast.error(response.mensagem);
      console.log(response);
    }
  };

  return (
    <>
      <Modal
        isOpen={show}
        toggle={toggle}
        backdrop={"static"}
        id="staticBackdrop"
        centered
        className="modal-lg"
      >
        <ModalHeader
          className="modal-title"
          id="staticBackdropLabel"
          toggle={toggle}
        >
          Dados da Rede
        </ModalHeader>
        <ModalBody className="text-left p-5">
          <Row className="mb-3">
            <Col md="6" className="mb-3">
              <Label>Nome da rede:</Label>
              <Input
                type="text"
                placeholder="Nome da rede"
                value={nome}
                onChange={(e) => {
                  setNome(e.target.value);
                }}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>Moeda:</Label>
              <Input
                type="text"
                placeholder="Moeda"
                value={moeda}
                onChange={(e) => {
                  setMoeda(e.target.value.toUpperCase());
                }}
                maxLength={10}
              />
              <small className="text-muted">Somente as iniciais da moeda</small>
            </Col>

            <Col md="6" className="mb-3">
              <Label>Decimais:</Label>
              <Input
                type="number"
                placeholder="Decimais"
                value={decimals}
                onChange={(e) => {
                  setDecimals(e.target.value);
                }}
                maxLength={2}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>RPC:</Label>
              <Input
                type="text"
                placeholder="RPC"
                value={rpc}
                onChange={(e) => {
                  setRpc(e.target.value);
                }}
                maxLength={255}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>Network ID</Label>
              <Input
                type="number"
                placeholder="Network ID"
                value={networkId}
                onChange={(e) => {
                  setNetworkId(e.target.value);
                }}
                maxLength={7}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>Block Explorer:</Label>
              <Input
                type="text"
                placeholder="Block Explorer"
                value={blockExplorer}
                onChange={(e) => {
                  setBlockExplorer(e.target.value);
                }}
                maxLength={255}
              />
            </Col>
            <Col md="6" className="mb-3">
              <Label>Taxa de retirada:</Label>
              <Input
                type="number"
                placeholder="Taxa de retirada"
                value={taxaRetirada}
                onChange={(e) => {
                  setTaxaRetirada(e.target.value);
                }}
                maxLength={30}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row className="mb-3">
            <div className="hstack gap-3 justify-content-right mt-3">
              <Button
                color="success"
                onClick={() => atualizarRede()}
                disabled={loading}
              >
                Editar
              </Button>
              <Button color="light" onClick={() => setShowModal(false)}>
                Fechar
              </Button>
            </div>
          </Row>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default ModalEditarRede;
